import type { EventHandler, KeyboardEvent, MouseEvent } from 'react';

const useKeyPress = <T extends HTMLElement>(
  onClick: (e: MouseEvent<T> | KeyboardEvent<T>) => void
): { onKeyDown: (event: KeyboardEvent<T>) => void } => {
  const handleKeyDown: EventHandler<KeyboardEvent<T>> = (event): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      onClick(event);
    }
  };

  return { onKeyDown: handleKeyDown };
};

export default useKeyPress;
